import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    TextField,
    Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { InvitationEmails } from "./InvitationEmails";

type PreparedSessionData = {
    session: {
        id: number;
        title: string;
        isTeamMeeting: boolean;
    };
    emailsToSend: Array<string>;
};

type ConfirmMeetingDialogProps = {
    open: boolean;
    toggleOpen: () => void;
    data: PreparedSessionData;
    additionalEmails: Array<string>;
    setAdditionalEmails: Dispatch<SetStateAction<Array<string>>>;
    title: string;
    setTitle: Dispatch<SetStateAction<string>>;
    onSubmit: () => void;
    disableSubmitButton: boolean;
    meetingName: string
};

export const ConfirmMeetingDialog = ({
    open,
    toggleOpen,
    additionalEmails = [],
    setAdditionalEmails,
    data,
    title,
    setTitle,
    onSubmit,
    disableSubmitButton,
    meetingName
}: ConfirmMeetingDialogProps) => {
    const closeDialog = (toggleFn: () => void) => {
        toggleFn();
        setAdditionalEmails([]);
    };

    return (
        <Dialog open={open} onClose={toggleOpen} aria-labelledby="dialog-title" maxWidth="sm" fullWidth>
            <DialogTitle id="dialog-title">Confirmação dos Dados</DialogTitle>
            <DialogContent>
                <Divider sx={{ mb: 2 }} />

                <Box mb={4}>
                    <Typography sx={{ fontWeight: "bold", color: "primary.dark" }} variant="subtitle2">
                        Título do convite
                    </Typography>
                    <TextField
                        size="small"
                        margin="dense"
                        InputLabelProps={{ sx: { fontSize: "0.9rem" } }}
                        variant="outlined"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        fullWidth
                        multiline
                        rows={2}
                    />
                </Box>
                <InvitationEmails
                    clientEmail={data.session.isTeamMeeting ? null : data.emailsToSend[0]}
                    additionalEmails={additionalEmails}
                    setAdditionalEmails={setAdditionalEmails}
                    meetingName={meetingName}
                />
            </DialogContent>
            <DialogActions sx={{ padding: 4 }}>
                <Button onClick={() => closeDialog(toggleOpen)} color="secondary">
                    Cancelar
                </Button>
                <Button disabled={disableSubmitButton} onClick={onSubmit} color="primary" variant="contained">
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
